// Despite the `use` filename, these are standalone async helpers rather than
// React hooks. Filename matches the spec for this feature.
import { supabase } from '../lib/supabase'

type SetParams = {
  householdId:    string
  recipeId:       string
  ingredientName: string
  forcedHasIt:    boolean
}

type ClearParams = Omit<SetParams, 'forcedHasIt'>

/** Normalize the ingredient name consistently between writes and reads. */
export function normalizeIngredientName(name: string): string {
  return name.toLowerCase().trim()
}

export async function setIngredientOverride({
  householdId,
  recipeId,
  ingredientName,
  forcedHasIt,
}: SetParams): Promise<{ ok: boolean; error?: string }> {
  const { error } = await supabase
    .from('recipe_ingredient_overrides')
    .upsert(
      {
        household_id:    householdId,
        recipe_id:       recipeId,
        ingredient_name: normalizeIngredientName(ingredientName),
        forced_has_it:   forcedHasIt,
        updated_at:      new Date().toISOString(),
      },
      { onConflict: 'household_id,recipe_id,ingredient_name' },
    )
  if (error) return { ok: false, error: error.message }
  return { ok: true }
}

export async function clearIngredientOverride({
  householdId,
  recipeId,
  ingredientName,
}: ClearParams): Promise<{ ok: boolean; error?: string }> {
  const { error } = await supabase
    .from('recipe_ingredient_overrides')
    .delete()
    .eq('household_id',    householdId)
    .eq('recipe_id',       recipeId)
    .eq('ingredient_name', normalizeIngredientName(ingredientName))
  if (error) return { ok: false, error: error.message }
  return { ok: true }
}
